'use client'
import React, { useEffect, useRef } from 'react'
import { IDEWorkspace, IDEWorkspaceMobile } from '@/components/ide/ide-workspace'
import { useIsMobile } from '@/hooks/use-mobile'
import { useParams, useNavigate } from 'react-router-dom'
import { useActiveThemeId } from '@/hooks/useActiveThemeId'

export default function Home() {
  const isMobile = useIsMobile()
  const { siteSlug, themeBuildId } = useParams<{ siteSlug: string; themeBuildId?: string }>()
  const navigate = useNavigate()
  const { themeId, isLoading: themeLoading } = useActiveThemeId(siteSlug)
  const createInFlightRef = useRef(false)

  useEffect(() => {
    if (!siteSlug || themeBuildId || themeLoading || !themeId) return
    if (createInFlightRef.current) return

    const createConversation = async () => {
      createInFlightRef.current = true
      try {
        const response = await fetch(
          `/sites/${siteSlug}/themes/${themeId}/theme_builds`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name=\"csrf-token\"]')?.getAttribute('content') || ''
            }
          }
        )

        if (response.ok) {
          const data = await response.json()
          if (data.theme_build?.id) {
            navigate(`/sites/${siteSlug}/devEditor/${data.theme_build.id}`, { replace: true })
          }
        } else {
          createInFlightRef.current = false
          console.error('Failed to create conversation:', await response.text())
        }
      } catch (error) {
        createInFlightRef.current = false
        console.error('Failed to create conversation:', error)
      }
    }

    createConversation()
  }, [siteSlug, themeBuildId, themeLoading, themeId, navigate])

  if (!themeBuildId) {
    return (
      <div className="h-screen w-screen flex items-center justify-center text-muted-foreground">
        Loading conversation...
      </div>
    )
  }

  return isMobile ? <IDEWorkspaceMobile /> : <IDEWorkspace />
}
